import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { GotovinskiKomitent } from './gotovinski-komitent';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-gotovinski-komitent-modal-update',
  templateUrl: './gotovinski-komitent-modal-update.component.html'
})
export class GotovinskiKomitentModalUpdateComponent extends BaseModalUpdateComponent<GotovinskiKomitent> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<GotovinskiKomitent>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
    super.ngOnInit();

  }

}
